export default "__VITE_ASSET__CyvA0X62__"